import axios from 'axios'

import { CgiCollectRequest, CgiCollectResult, IsMrmResponse, CgiActivateResult, SubmissionResponse } from '../interfaces/API'
import { CgiProvider } from '../interfaces/CGI';

const client = axios.create({
    baseURL: process.env.AEA_API_URL
});

export const activateCGI = (provider: CgiProvider) => {
    const url = '/umbraco/surface/Cgi/Activate';
    return client.post<CgiActivateResult>(url, { provider })
}

export const loginWithoutCGI = (personalIdentityNumber: string) => {
    const url = '/umbraco/surface/Cgi/LoginWithoutCGI';
    return client.post<CgiCollectResult>(url, { personalIdentityNumber })
}

export const checkForCGISignature = (request: CgiCollectRequest) => {
    const cgiClient = axios.create({
        baseURL: process.env.AEA_API_URL
    });
    const url = '/umbraco/surface/Cgi/CheckForSignature'
    return cgiClient.post<CgiCollectResult>(url, request);
}

export const isMrmProduction = () => {
    var url = '/umbraco/surface/ApplyForMembership/IsMrmProduction';
    return client.get<IsMrmResponse>(url);
}

export const sendApplication = (dataToSend: any) => {
    var url = '/umbraco/surface/ApplyForMembership/Apply';
    return client.post<SubmissionResponse>(url, dataToSend);
}

export const sendApplicationNoEId = (dataToSend: any) => {
    var url = '/umbraco/surface/ApplyForMembership/ApplyWithoutEId';
    return client.post<SubmissionResponse>(url, dataToSend);
}

export const logOnServer = (data: any, errorTitle: string, useWarningLevel: boolean = false) => {
    var url = '/umbraco/surface/Utility/LogInfo';
    return client.post(url, { data, errorTitle, useWarningLevel });
}